import { useParams } from "react-router-dom";

import { LoadingState } from "~/common/components";
import { ConsultationCompleted } from "~/patients/components/consultations/shared";
import {
  useCompleteScreening,
  useGetCurrentPatient,
  useGetCurrentScreeningBundle,
} from "~/patients/hooks";

interface ScreeningCompletedScreenProps {
  handleGoBackFinalScreen: () => void;
  isNavigatingBack: boolean;
}
export const ScreeningCompletedScreen = ({
  handleGoBackFinalScreen,
  isNavigatingBack,
}: ScreeningCompletedScreenProps) => {
  const { data: user } = useGetCurrentPatient();
  const consultationId = user?.consultation?.id;

  const { id: patientScreeningId } = useParams();
  const { completeScreeningMutation, isPending } = useCompleteScreening();
  const { data, isLoading, isFetching } = useGetCurrentScreeningBundle();

  if (!data) return;

  const { sections_completed, total_sections } = data;
  const sectionCompleted = (sections_completed ?? 0) + 1;
  const isFinalScreening = sectionCompleted === total_sections;

  const title = `You’ve completed Section ${sectionCompleted}!`;

  const subtitle = isFinalScreening
    ? "You can’t edit your answers once you submit and continue."
    : "You can’t edit your answers once you move to the next section.";

  const continueLabel = isFinalScreening
    ? "Submit and continue"
    : "Continue to next section";

  const handleCompleteScreening = () =>
    patientScreeningId &&
    completeScreeningMutation({ id: patientScreeningId, consultationId });

  if (isLoading || isFetching) return <LoadingState />;

  return (
    <ConsultationCompleted
      handleGoBackFinalScreen={handleGoBackFinalScreen}
      title={title}
      subtitle={subtitle}
      isLoading={isLoading}
      isPending={isPending}
      isNavigatingBack={isNavigatingBack}
      handleComplete={handleCompleteScreening}
      continueLabel={continueLabel}
    />
  );
};
